import { z } from 'zod';

import { size, isString } from '../../../utils/common.util';

export const MinLengthValidationBlockSchema = z.number().int().positive();
export type MinLengthValidationBlock = z.infer<
  typeof MinLengthValidationBlockSchema
>;

type IsMinLength = (value: unknown, block: MinLengthValidationBlock) => boolean;
export const isMinLength: IsMinLength = (value, block) => {
  if (!isString(value)) {
    return false;
  }

  return size(value) >= block;
};
